import React from 'react';
import '../../styles/stats-panel.css';

const StatsPanel = ({ stats, templatesCount, loading }) => {
  if (loading) {
    return (
      <div className="fitness-stats-panel">
        <div className="fitness-stats-grid">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="fitness-stat-card loading">
              <div className="fitness-stat-skeleton">
                <div className="skeleton-value"></div>
                <div className="skeleton-label"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  const statCards = [
    {
      title: 'Сегодня',
      subtitle: 'записей',
      value: stats?.todayBookings || 0,
      icon: '📋',
      color: 'primary',
      trend: '+12%',
      trendType: 'positive'
    },
    {
      title: 'За неделю',
      subtitle: 'записей', 
      value: stats?.weeklyBookings || 0,
      icon: '📊',
      color: 'info',
      trend: '+8%',
      trendType: 'positive'
    },
    {
      title: 'Активных',
      subtitle: 'занятий',
      value: stats?.activeClasses || 0,
      icon: '🏋️',
      color: 'warning'
    },
    {
      title: 'Завершено',
      subtitle: 'посещений',
      value: stats?.completedBookings || 0,
      icon: '✅',
      color: 'success'
    },
    {
      title: 'Шаблонов',
      subtitle: 'создано',
      value: templatesCount || 0,
      icon: '📑',
      color: 'secondary'
    }
  ];

  return (
    <div className="fitness-stats-panel">
      <div className="fitness-stats-grid">
        {statCards.map((card, index) => (
          <div key={index} className={`fitness-stat-card ${card.color}`}>
            <div className="fitness-stat-header">
              <div className="fitness-stat-icon-wrapper">
                <span className="fitness-stat-icon">{card.icon}</span>
              </div>
              {card.trend && (
                <span className={`fitness-stat-trend ${card.trendType || 'neutral'}`}>
                  {card.trend}
                </span>
              )}
            </div>
            <div className="fitness-stat-content">
              <div className="fitness-stat-value">
                {card.value.toLocaleString('ru-RU')}
              </div>
              <div className="fitness-stat-label">
                <span className="fitness-stat-title">{card.title}</span>
                {' '}
                <span className="fitness-stat-subtitle">{card.subtitle}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StatsPanel;
